<div class="d-flex block-layer-btn">
  <button *ngIf="getGroup(mapToolsKeys.PG_MAP_SHAPE_DRAWING_TOOLS)?.hasAccess"
          [matMenuTriggerFor]="shapeDrawingTools"
          class="border-0 p-0 d-none d-md-block"
          aria-label="Drawing Tools"
          data-tooltip-position="down-left">
    <i class="fas fa-pen" aria-hidden="true"></i><span class="sr-only">Drawing tools</span>
  </button>

  <span class="m-0 p-0 divider"></span>

  <button *ngIf="getGroup(mapToolsKeys.PG_MAP_BOUNDARIES)?.hasAccess"
          [matMenuTriggerFor]="mapBoundaries"
          class="border-0 p-0"
          aria-label="Boundaries"
          data-tooltip-position="below">
    <i class="fas fa-layer-group" aria-hidden="true"></i><span class="sr-only">Boundaries</span>
  </button>

  <span class="m-0 p-0 divider"></span>

  <ng-container *ngIf="(isPremiumLayerWorks$ | async)">
    <button *ngIf="isMySearch && { isSingleCountyCheck: isSingleCounty$ | async } as valueCheck"
            [disabled]="!valueCheck.isSingleCountyCheck"
            [matMenuTriggerFor]="mapPremium"
            [ngClass]="{ 'disabled-map': !valueCheck.isSingleCountyCheck }"
            class="border-0 p-0 premium-btn"
            aria-label="Premium Map"
            data-tooltip-position="below">
    </button>
  </ng-container>

  <span class="m-0 p-0 divider"></span>

  <button *ngIf="getGroup(mapToolsKeys.PG_MAP_LAYERS)?.hasAccess"
          [matMenuTriggerFor]="propertyAndSales"
          class="border-0 p-0"
          aria-label="Property & Sales"
          data-tooltip-position="below"
          (menuOpened)="onMenuOpened(mapToolsKeys.PG_MAP_LAYERS)">
    <i class="fas fa-map-pin" aria-hidden="true"></i><span class="sr-only">Property & Sales</span>
  </button>

  <span class="m-0 p-0 divider"></span>

  <button *ngIf="getGroup(mapToolsKeys.PG_MAP_TRENDS_LAYER)?.hasAccess"
          [matMenuTriggerFor]="trends"
          class="border-0 p-0"
          aria-label="Trends"
          data-tooltip-position="below"
          (menuOpened)="onMenuOpened(mapToolsKeys.PG_MAP_TRENDS_LAYER)">
    <i class="fas fa-chart-bar" aria-hidden="true"></i><span class="sr-only">Trends</span>
  </button>

  <span class="m-0 p-0 divider"></span>

  <button *ngIf="getGroup(mapToolsKeys.PREF_MAP_POINTS_OF_INTEREST)?.hasAccess"
          [matMenuTriggerFor]="pointsOfInterest"
          class="border-0 p-0"
          aria-label="Points Of Interest"
          data-tooltip-position="below">
    <i class="fas fa-binoculars" aria-hidden="true"></i><span class="sr-only">Points Of Interest</span>
  </button>

  <span class="m-0 p-0 divider"></span>

  <button *ngIf="getGroup(mapToolsKeys.PREF_MAP_DRIVING_DIRECTIONS)?.hasAccess"
          [matMenuTriggerFor]="drivingDirections"
          class="border-0 p-0"
          aria-label="Driving Directions"
          data-tooltip-position="below">
    <i class="fas fa-car-side" aria-hidden="true"></i><span class="sr-only">Driving Directions</span>
  </button>

  <span class="m-0 p-0 divider"></span>

  <button class="border-0 p-0"
          [matMenuTriggerFor]="locateOnMap"
          (menuClosed)="locateOnMapTool.emit(false)"
          (menuOpened)="locateOnMapTool.emit(true)"
          aria-label="Locate on the Map"
          data-tooltip-position="below">
    <i class="fas fa-map-marked" aria-hidden="true"></i><span class="sr-only">Locate on the Map</span>
  </button>

  <span class="m-0 p-0 divider"></span>

  <button class="border-0 p-0 d-none d-md-block"
          [matMenuTriggerFor]="rulerTool"
          aria-label="Ruler"
          data-tooltip-position="below"
          (click)="this.openDrawingTool(drawingTools.POLYLINE)">
    <i class="fas fa-ruler" aria-hidden="true"></i><span class="sr-only">Ruler</span>
  </button>

  <span class="m-0 p-0 divider"></span>

  <button class="border-0 p-0 d-none d-md-block"
          [matMenuTriggerFor]="annotationTool"
          aria-label="Annotation tool"
          data-tooltip-position="below"
          (click)="useAnnotationTool.emit()">
    <i class="fas fa-comment-alt-lines" aria-hidden="true"></i><span class="sr-only">Annotation tool</span>
  </button>

  <span class="m-0 p-0 divider"></span>

  <button class="clear-all-btn border-0 d-none d-md-block"
          *ngIf="hasClearAll"
          (click)="clearSelectedLayers.emit()">
    Clear all
  </button>

  <mat-menu #shapeDrawingTools class="shape-drawing-tools map-mat-menu-item dsm-nav">
    <div class="map-menu-item">
      <h3 class="shape-header">Shape Drawing Tools</h3>
      <button mat-menu-item
              class="d-flex button--drawing-tools"
              [ngClass]="{'active': selectedDrawingTool === drawingTools.CIRCLE}"
              (click)="this.openDrawingTool(drawingTools.CIRCLE)">
        <i class="icon circle d-block" aria-hidden="true"></i>Radius Tool
      </button>
      <button mat-menu-item
              class="d-flex button--drawing-tools"
              [ngClass]="{'active': selectedDrawingTool === drawingTools.RECTANGLE}"
              (click)="this.openDrawingTool(drawingTools.RECTANGLE)">
        <i class="icon square d-block" aria-hidden="true"></i>Rectangle Tool
      </button>
      <button mat-menu-item
              class="d-flex button--drawing-tools"
              [ngClass]="{'active': selectedDrawingTool === drawingTools.POLYGON}"
              (click)="this.openDrawingTool(drawingTools.POLYGON)">
        <i class="icon polygon d-block" aria-hidden="true"></i>Polygon Tool
      </button>
      <p class="m-0 shape-footer">
        <span class="d-block">Drawing Tool</span>
        Select a Drawing Tool above, then click on the map to start drawing a search area
      </p>
    </div>
  </mat-menu>

  <mat-menu #pointsOfInterest class="map-mat-menu-item dsm-nav">
    <rlst-map-points-of-interest></rlst-map-points-of-interest>
  </mat-menu>

  <mat-menu #mapBoundaries class="map-mat-menu-item map-mat-menu-item--boundaries dsm-nav">
    <rlst-map-boundaries></rlst-map-boundaries>
  </mat-menu>

  <mat-menu #mapPremium class="map-mat-menu-item map-mat-menu-item--boundaries">
    <rlst-map-premium></rlst-map-premium>
  </mat-menu>

  <mat-menu #propertyAndSales class="map-mat-menu-item dsm-nav">
    <rlst-property-sales [index]="propertySalesMenuOpenIndex"></rlst-property-sales>
  </mat-menu>

  <mat-menu #trends class="map-mat-menu-item dsm-nav">
    <rlst-map-trends [index]="trendMenuOpenIndex"></rlst-map-trends>
  </mat-menu>

  <mat-menu #drivingDirections class="map-mat-menu-item dsm-nav">
    <rlst-driving-directions (closeDriveDirection)="drivingDirections.closed.emit()"></rlst-driving-directions>
  </mat-menu>

  <mat-menu #rulerTool class="map-mat-menu-item dsm-nav">
    <div class="map-menu-item ruler-tool">
      <p class="m-0">
        <span class="d-block">Measurement Tool</span>
        To begin, click and release mouse
        for the first and subsequent points.
        To finish, double-click the last point.
      </p>
    </div>
  </mat-menu>

  <mat-menu #annotationTool class="map-mat-menu-item dsm-nav">
    <div class="map-menu-item ruler-tool">
      <p class="m-0">
        <span class="d-block"> Annotation Tool</span>
        Click on a map to add an annotation.
        To change annotation position, drag the blue pin.
      </p>
    </div>
  </mat-menu>

  <mat-menu #locateOnMap class="map-mat-menu-item dsm-nav">
    <rlst-locate-on-map></rlst-locate-on-map>
  </mat-menu>
</div>
